import { DetailsList, Text, ICommandBarItemProps, IDialogContentProps, Selection, DetailsListLayoutMode, SelectionMode, CheckboxVisibility, IColumn, IDetailsListStyles, DetailsHeader, CommandBar, MessageBar, ICommandBarStyles, IButtonProps, MessageBarType, DialogType, Dialog, DialogFooter, PrimaryButton, DefaultButton, Icon, ContextualMenu, IContextualMenuItem, TooltipHost, Link, TooltipOverflowMode, ITooltipHostStyles } from '@fluentui/react';
import React from 'react'
import { connect, ConnectedProps } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { checkRoles } from '../../../hoc/CheckRoles';
import { DataType, getLabelFromDataType, RoleContext } from '../../../shared/enums';
import { IColonnaGenerale } from '../../../shared/interfaces';
import { RootState } from '../../../store';
import CircleLoader from '../../Loader/CircleLoader/CircleLoader';
import abilityBuild from '../../../shared/CASL/appAbility';
import { Unsubscribe } from "@casl/ability";
import CustomCommandBarMenuItem from '../../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';
import colonneGeneraliService from '../../../services/colonneGenerali.service';
import { toastRef } from '../../Layout/Layout';
import AddEditCustomColumnsManager from './AddEditCustomColumnsManager';


const commandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee' },
};

const tooltipHostStyles: Partial<ITooltipHostStyles> = {
    root: {
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'

    }
};

const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: []
    },
};

const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo,
    currentUser: state.sessionReducer.currentUser,
    features: state.sessionReducer.features,
    allRoles: state.sessionReducer.allRoles,
    isMobile: state.sessionReducer.isMobile,
})

const mapDispatch = {

}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface CustomColumnsManagerProps {

}

type Props = CustomColumnsManagerProps & RouteComponentProps & PropsFromRedux;

export interface CustomColumnsManagerState {
    commandBarItems: ICommandBarItemProps[]
    items: IColonnaGenerale[]
    columns: IColumn[]
    selectedColonnaGenerale?: IColonnaGenerale
    lateralPanelIsOpen: boolean
    lateralPanelBodyContent: Function
    lateralPanelSubmitFunction: Function
    confirmDialogIsOpen: boolean
    confirmDialogContentProps: IDialogContentProps
    confirmDialogSubmitFunction: Function
    loadingColonneGeneraliList: boolean
    forceColonnaGeneraleManagerTableRefresh: boolean
    showMessageBar: boolean
    userMessageError: string
    showContextualMenu: boolean
    contextMenuItems: IContextualMenuItem[] | undefined
    contextMenuPosition: any

}
class CustomColumnsManager extends React.Component<Props, CustomColumnsManagerState> {
    cancelTokenSources = {};
    unsubscribeFromAbility: Unsubscribe = () => { };
    private colonnaGeneraleSelection: Selection | undefined;

    constructor(props) {
        super(props);

        this.colonnaGeneraleSelection = new Selection({
            onSelectionChanged: () => {
                const selection = this.colonnaGeneraleSelection!.getSelection()[0] as IColonnaGenerale;
                this.setState({ selectedColonnaGenerale: selection })
            }
        })

        this.state = {
            commandBarItems: [],
            items: [],
            columns: [
                {
                    key: 'displayName',
                    fieldName: 'displayName',
                    name: 'Nome',
                    minWidth: 100,
                    maxWidth: 200,
                    isResizable: true,
                    onRender: (item) => {
                        return (
                            <TooltipHost
                                key={`tooltip_${item.displayName}`}
                                content={item.displayName}
                                styles={tooltipHostStyles}
                                overflowMode={TooltipOverflowMode.Self}
                            >
                                <Link key={`link-${item.id}`} onClick={(ev) => this.itemRowClickHandler(item)}>{item.displayName}</Link>
                            </TooltipHost>
                        );
                    }
                },
                {
                    key: 'internalName',
                    fieldName: 'internalName',
                    name: 'Nome interno',
                    minWidth: 100,
                    maxWidth: 200,
                    isResizable: true,
                    onRender: (item) => {
                        return (
                            <TooltipHost
                                key={`tooltip_${item.internalName}`}
                                content={item.internalName}
                                styles={tooltipHostStyles}
                                overflowMode={TooltipOverflowMode.Self}
                            >
                                {item.internalName}
                            </TooltipHost>
                        );
                    }
                },
                {
                    key: 'type',
                    fieldName: 'type',
                    name: 'Tipo',
                    minWidth: 100,
                    maxWidth: 200,
                    isResizable: true,
                    onRender: this.onRenderTypeColumn
                },
                {
                    key: 'system',
                    fieldName: 'system',
                    name: 'Sistema',
                    minWidth: 100,
                    maxWidth: 100,
                    onRender: (item) => {
                        if (item.system) {
                            return <span><Icon iconName={"CheckMark"} style={{ color: 'green', fontSize: '15px', fontWeight: 'bold' }} /></span>
                        }
                    }
                },
                {
                    key: 'required ',
                    fieldName: 'required',
                    name: 'Obbligatorio',
                    minWidth: 100,
                    maxWidth: 100,
                    onRender: (item) => {
                        if (item.required) {
                            return <span><Icon iconName={"CheckMark"} style={{ color: 'green', fontSize: '15px', fontWeight: 'bold' }} /></span>
                        }
                    }
                },
                {
                    key: 'readonly',
                    fieldName: 'readonly',
                    name: 'Sola lettura',
                    minWidth: 100,
                    maxWidth: 100,
                    onRender: (item) => {
                        if (item.readOnly) {
                            return <span><Icon iconName={"CheckMark"} style={{ color: 'green', fontSize: '15px', fontWeight: 'bold' }} /></span>
                        }
                    }
                },
                {
                    key: 'configuration',
                    fieldName: 'configuration',
                    name: 'Configurazioni',
                    minWidth: 100,
                    isResizable: true,
                    onRender: this.renderColumnConfigurations
                },

                /// Aggiungo una colonna vuota in coda alla tabella, è necessaria per consentire l'allineamneto tra
                /// l'header e i contenuti della tabella 
                {
                    key: 'empty',
                    name: 'empty',
                    fieldName: 'empty',
                    isIconOnly: true,
                    minWidth: 1,
                    maxWidth: 1,
                    onRender: (item) => {

                    },
                },
            ],
            lateralPanelIsOpen: false,
            lateralPanelBodyContent: () => { },
            lateralPanelSubmitFunction: () => { },
            confirmDialogIsOpen: false,
            confirmDialogContentProps: {},
            confirmDialogSubmitFunction: () => { },
            loadingColonneGeneraliList: false,
            forceColonnaGeneraleManagerTableRefresh: false,
            showMessageBar: false,
            userMessageError: "",
            showContextualMenu: false,
            contextMenuItems: [],
            contextMenuPosition: undefined
        }

    }

    componentDidMount() {
        this.unsubscribeFromAbility = abilityBuild.on('updated', () => {
            if (abilityBuild.cannot('create', 'IColonnaGenerale')) {
                this.props.history.push({ pathname: '/unauthorized' });
            }
            this.updateCommandBarItems();
        });

        if (this.props.currentAoo) {
            this.updateCommandBarItems();
        }
        this.getColonneGenerali();

    }

    componentDidUpdate(oldProps: Props, oldState: CustomColumnsManagerState) {

        if (oldProps.currentAoo !== this.props.currentAoo
            || oldState.selectedColonnaGenerale !== this.state.selectedColonnaGenerale) {
            this.updateCommandBarItems();
        }

        if (oldProps.currentAoo !== this.props.currentAoo) {
            this.getColonneGenerali();
        }

        if (oldState.forceColonnaGeneraleManagerTableRefresh !== this.state.forceColonnaGeneraleManagerTableRefresh) {
            this.setState({
                loadingColonneGeneraliList: true,
                items: []
            });
            this.colonnaGeneraleSelection?.setItems([]);
            this.getColonneGenerali();
        }
    }

    componentWillUnmount() {
        this.unsubscribeFromAbility();
    }

    getColonneGenerali() {
        this.setState({ loadingColonneGeneraliList: true });
        colonneGeneraliService.getColonneGenerali()
            .then(colonneGenerali => {
                this.setState({ items: colonneGenerali, loadingColonneGeneraliList: false })
            }).catch(error => {
                this.setState({ loadingColonneGeneraliList: false })
                if (!error.isErrorShown) {
                    toastRef.current?.show({
                        severity: 'error',
                        summary: 'Attenzione',
                        detail: `Non è stato possibile recuperare le informazioni`,
                        life: 5000
                    });
                }

            });
    }

    updateCommandBarItems = () => {

        let newCommandBarItems: ICommandBarItemProps[] = [];
        if (abilityBuild.can('create', 'IColonnaGenerale'))
            newCommandBarItems.push(
                {
                    key: 'addColonnaGenerale',
                    iconProps: { iconName: 'Add' },
                    text: 'Aggiungi',
                    onClick: this.addColonnaGeneraleManagerHandler
                });

        if (this.state.selectedColonnaGenerale) {
            let isReadOnly = this.state.selectedColonnaGenerale.readOnly || this.state.selectedColonnaGenerale.system;
            if (abilityBuild.can('update', 'IColonnaGenerale') && !isReadOnly) {
                newCommandBarItems.push({
                    key: 'editColonnaGenerale',
                    iconProps: { iconName: 'Edit' },
                    text: 'Modifica',
                    onClick: this.editColonnaGeneraleManagerHandler
                });
            }
            else if (abilityBuild.can('read', 'IColonnaGenerale') && isReadOnly) {
                newCommandBarItems.push({
                    key: 'viewColonnaGenerale',
                    text: 'Visualizza',
                    iconProps: { iconName: 'View' },
                    onClick: this.viewColonnaGeneraleManagerHandler
                });
            }
        }

        this.setState({ commandBarItems: newCommandBarItems });
    }


    onRenderDetailsHeader = (detailsHeaderProps) => {
        const detailsListHeadrerStyles: Partial<IDetailsListStyles> = {

            root: { boxSizing: 'content-box !important' }

        };
        return (
            <DetailsHeader
                {...detailsHeaderProps}
                styles={detailsListHeadrerStyles}
            />
        );
    }

    onRenderTypeColumn = (item?: IColonnaGenerale, index?: number | undefined, column?) => {
        if (item) {
            let convertedDataType = getLabelFromDataType(item.type);

            return (
                <TooltipHost
                    key={`tooltip_${item.type}`}
                    content={convertedDataType}
                    styles={tooltipHostStyles}
                    overflowMode={TooltipOverflowMode.Self}
                >
                    {convertedDataType}
                </TooltipHost>
            );
        }
        else {
            return <React.Fragment></React.Fragment>
        }
    }

    // Click sul nome della colonna (link) 
    itemRowClickHandler = (item: IColonnaGenerale) => {
        let isReadOnly = item.readOnly || item.system;
        if (abilityBuild.can('update', 'IColonnaGenerale') && !isReadOnly) {
            this.editColonnaGeneraleManagerHandler();
        }
        else if (abilityBuild.can('read', 'IColonnaGenerale') && isReadOnly) {
            this.viewColonnaGeneraleManagerHandler();
        }
    }
    // Click sul button della commandbar - Aggiungi cassetta
    addColonnaGeneraleManagerHandler = () => {

        this.setState(
            {
                lateralPanelIsOpen: true,
                lateralPanelBodyContent: () => <AddEditCustomColumnsManager
                    panelIsOpen={this.state.lateralPanelIsOpen}
                    panelHeaderText='Nuova colonna'
                    loading={false}
                    onSubmit={this.addColonnaGeneraleLateralPanelSubmit}
                    onDismiss={this.dismissLateralPanel}
                    panelIsReadOnlyMode={false}
                />
            }
        );
        this.colonnaGeneraleSelection!.setAllSelected(false);
    }

    // Click su salva del panel laterale - Aggiungi colonnaGenerale
    addColonnaGeneraleLateralPanelSubmit = (colonnaGenerale: Partial<IColonnaGenerale>) => {
        this.setState({
            lateralPanelIsOpen: false,
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: `Vuoi aggiungere la colonna "${colonnaGenerale.displayName}"?`,
            },
            confirmDialogSubmitFunction: () => { this.addColonnaGeneraleConfirmDialogSubmit(colonnaGenerale) }
        })
    }

    //// Click su conferma del confirm dialog - Aggiungi colonnaGenerale
    addColonnaGeneraleConfirmDialogSubmit = (colonnaGenerale: Partial<IColonnaGenerale>) => {
        if (this.props.currentAoo) {
            this.setState({ loadingColonneGeneraliList: true });
            let { forceColonnaGeneraleManagerTableRefresh } = this.state;

            colonneGeneraliService.createColonnaGenerale(colonnaGenerale)
                .then(result => {
                    this.setState({
                        forceColonnaGeneraleManagerTableRefresh: !forceColonnaGeneraleManagerTableRefresh,
                    });
                    toastRef.current?.show({
                        severity: 'info',
                        summary: colonnaGenerale.displayName,
                        detail: `Colonna aggiunta correttamente`,
                        life: 5000
                    });
                })
                .catch(error => {
                    this.setState({ loadingColonneGeneraliList: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: colonnaGenerale.displayName,
                            detail: `Non è stato possibile aggiungere la colonna`,
                            life: 5000
                        });
                    }
                })

            this.setState({ confirmDialogIsOpen: false, loadingColonneGeneraliList: false })
        }
    }

    //// Click sul button della commandbar - Modifica colonnaGenerale
    editColonnaGeneraleManagerHandler = () => {
        this.setState(
            {
                lateralPanelIsOpen: true,
                lateralPanelBodyContent: () => <AddEditCustomColumnsManager
                    panelIsOpen={this.state.lateralPanelIsOpen}
                    panelHeaderText='Modifica colonna'
                    loading={false}
                    selectedColonnaGenerale={this.state.selectedColonnaGenerale}
                    onSubmit={this.editColonnaGeneraleLateralPanelSubmit}
                    onDismiss={this.dismissLateralPanel}
                    panelIsReadOnlyMode={false}
                />
            }
        );
    }

    //// Click su salva del panel laterale - Modifica colonnaGenerale
    editColonnaGeneraleLateralPanelSubmit = (colonnaGenerale: Partial<IColonnaGenerale>) => {
        let { selectedColonnaGenerale } = this.state;
        if (selectedColonnaGenerale) {
            this.setState({
                lateralPanelIsOpen: false,
                confirmDialogIsOpen: true,
                confirmDialogContentProps: {
                    type: DialogType.normal,
                    title: 'Conferma',
                    closeButtonAriaLabel: 'Close',
                    subText: `Vuoi modificare la colonna ${selectedColonnaGenerale.displayName}?`,
                },
                confirmDialogSubmitFunction: () => { this.editColonnaGeneraleConfirmDialogSubmit(colonnaGenerale) }
            })
        }
    }

    //// Click su conferma del confirm dialog - Modifica colonnaGenerale
    editColonnaGeneraleConfirmDialogSubmit = (colonnaGenerale: Partial<IColonnaGenerale>) => {
        if (this.props.currentAoo) {
            this.setState({ loadingColonneGeneraliList: true });
            let { forceColonnaGeneraleManagerTableRefresh } = this.state;

            colonneGeneraliService.updateColonnaGenerale(colonnaGenerale!.id!, colonnaGenerale)
                .then(result => {
                    this.setState({ forceColonnaGeneraleManagerTableRefresh: !forceColonnaGeneraleManagerTableRefresh });
                    toastRef.current?.show({
                        severity: 'info',
                        summary: colonnaGenerale.displayName,
                        detail: `Colonna aggiornata correttamente`,
                        life: 5000
                    });
                })
                .catch(error => {
                    this.setState({ loadingColonneGeneraliList: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: colonnaGenerale.displayName,
                            detail: `Non è stato possibile aggiornare la colonna`,
                            life: 5000
                        });
                    }
                });

            this.setState({ confirmDialogIsOpen: false, loadingColonneGeneraliList: false });
            this.colonnaGeneraleSelection!.setAllSelected(false);
        }
    }

    //// Click sul button della commandbar - Visualizza colonnaGenerale
    viewColonnaGeneraleManagerHandler = () => {
        this.setState(
            {
                lateralPanelIsOpen: true,
                lateralPanelBodyContent: () => <AddEditCustomColumnsManager
                    panelIsOpen={this.state.lateralPanelIsOpen}
                    panelHeaderText='Dettagli colonna'
                    loading={false}
                    selectedColonnaGenerale={this.state.selectedColonnaGenerale}
                    onSubmit={this.editColonnaGeneraleLateralPanelSubmit}
                    onDismiss={this.dismissLateralPanel}
                    panelIsReadOnlyMode={true}
                />
            }
        );
    }



    dismissLateralPanel = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ lateralPanelIsOpen: false })
    }

    dismissConfirmDialog = () => {
        this.setState({ confirmDialogIsOpen: false })
    }

    // metodi gestione context menu 
    onShowContextualMenu = (item, index, ev) => {
        ev.preventDefault();

        const menuItems = this.updateContextMenuCustomColumnsManager();
        this.setState({ contextMenuItems: menuItems, showContextualMenu: true, contextMenuPosition: ev });
    };

    updateContextMenuCustomColumnsManager = () => {
        const menuItems: IContextualMenuItem[] = [];

        if (this.state.selectedColonnaGenerale) {
            let isReadOnly = this.state.selectedColonnaGenerale.readOnly || this.state.selectedColonnaGenerale.system;
            if (abilityBuild.can('update', 'IColonnaGenerale') && !isReadOnly) {
                menuItems.push(
                    {
                        key: 'edit',
                        text: 'Modifica',
                        iconProps: { iconName: 'Edit' },
                        onClick: () => {
                            this.editColonnaGeneraleManagerHandler();
                            this.onHideContextualMenu();
                        }
                    }
                );
            }
            else if (abilityBuild.can('read', 'IColonnaGenerale') && isReadOnly) {
                menuItems.push({
                    key: 'viewColonnaGenerale',
                    text: 'Visualizza',
                    iconProps: { iconName: 'View' },
                    onClick: () => {
                        this.viewColonnaGeneraleManagerHandler();
                        this.onHideContextualMenu();
                    }
                });

            }
        }
        return menuItems;
    };

    onHideContextualMenu = () => {
        this.setState({ contextMenuItems: undefined, showContextualMenu: false });
    };


    renderColumnConfigurations = (item: IColonnaGenerale) => {
        const config = item.configuration || {};
        let cellContent: any = <React.Fragment></React.Fragment>;
        let tooltipContent: any = <React.Fragment></React.Fragment>;
        let overflowMode: TooltipOverflowMode | undefined = TooltipOverflowMode.Self;
        switch (item.type) {
            case DataType.DateTime:
                tooltipContent = cellContent = (
                    <span>
                        <strong>Solo data: </strong>
                        {config.DateOnly ? "Sì" : "No"}
                    </span>
                );
                break;

            case DataType.Number:
            case DataType.Currency:
                if (config.Decimals && config.Decimals > 0)
                    tooltipContent = cellContent = (
                        <span>
                            <strong>Numero di cifre decimali: </strong>
                            {config.Decimals}
                        </span>
                    );
                break;

            case DataType.Choice:
                overflowMode = undefined;
                cellContent = (
                    <span>
                        <strong>Selezione multipla: </strong>
                        {`${config.Multi ? "Sì" : "No"}...`}
                    </span>

                );
                tooltipContent = (
                    <span>
                        <strong>Selezione multipla: </strong>
                        {config.Multi ? "Sì" : "No"}
                        <br />
                        <strong>Opzioni: </strong>
                        <ul style={{ margin: 0, paddingLeft: 20 }}>
                            {(config.Options || []).map((opt, idx) =>
                                <li key={idx}>{opt}</li>
                            )}
                        </ul>
                    </span>

                );
                break;

            case DataType.LookupList:
                tooltipContent = cellContent = (
                    <span>
                        <strong>Selezione multipla: </strong>
                        {config.Multi ? "Sì" : "No"}
                        <br />
                        <strong>
                            {item.type === DataType.LookupList && "Riferimento elenco: "}
                        </strong>
                        {config.ListName || ""}
                    </span>
                );
                break;

            case DataType.User:
                tooltipContent = cellContent = (
                    <span>
                        <strong>Selezione multipla: </strong>
                        {config.Multi ? "Sì" : "No"}
                    </span>
                );
                break;

        }

        return (
            <TooltipHost
                key={`tooltip_config_${item.internalName}`}
                content={tooltipContent}
                styles={tooltipHostStyles}
                overflowMode={overflowMode}
            >
                {cellContent}
            </TooltipHost>
        );

    }
    render() {

        return (
            <React.Fragment>
                {this.state.lateralPanelIsOpen && this.state.lateralPanelBodyContent()}

                <Dialog
                    hidden={!this.state.confirmDialogIsOpen}
                    onDismiss={this.dismissConfirmDialog}
                    dialogContentProps={this.state.confirmDialogContentProps}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={() => this.state.confirmDialogSubmitFunction()} text="Conferma" />
                        <DefaultButton onClick={this.dismissConfirmDialog} text="Annulla" />
                    </DialogFooter>
                </Dialog>

                <div className="users-manager-component" >

                    {this.state.commandBarItems.length > 0 &&
                        <CommandBar
                            overflowButtonProps={overflowProps}
                            items={this.state.commandBarItems}
                            styles={commandBarStyles}
                        />
                    }
                    {this.state.showMessageBar &&
                        <MessageBar
                            messageBarType={MessageBarType.blocked}
                            isMultiline={true}
                            onDismiss={() => this.setState({ showMessageBar: false })}
                            dismissButtonAriaLabel="Close">
                            {this.state.userMessageError}
                        </MessageBar>
                    }


                    <CircleLoader loaderClass='loader-large' loading={this.state.loadingColonneGeneraliList} />

                    {
                        this.state.items && this.state.items.length > 0
                            ? <DetailsList
                                className="with-empty-column"
                                items={this.state.items}
                                columns={this.state.columns}
                                layoutMode={DetailsListLayoutMode.justified}
                                onRenderDetailsHeader={this.onRenderDetailsHeader}
                                selection={this.colonnaGeneraleSelection}
                                selectionPreservedOnEmptyClick={true}
                                selectionMode={SelectionMode.single}
                                checkboxVisibility={CheckboxVisibility.onHover}
                                onItemContextMenu={this.onShowContextualMenu}
                            />
                            : <div style={{ marginLeft: '31px' }}>
                                <Text> Nessuna colonna da visualizzare</Text>
                            </div>
                    }
                    <ContextualMenu
                        items={this.state.contextMenuItems!}
                        hidden={!this.state.showContextualMenu}
                        target={this.state.contextMenuPosition}
                        onItemClick={this.onHideContextualMenu}
                        onDismiss={this.onHideContextualMenu}
                    />


                </div>

            </React.Fragment >
        )
    }
}

export default connector(checkRoles(CustomColumnsManager, RoleContext.Aoo));